module.exports = __webpack_public_path__ + "static/media/S1-17-Kromyn-B-cod17.cdf3f06b.png";